const colors = {
    black: '#000',
    pink: '#F19EC9',
    yellow: '#FBE75A',
    blue: '#7BB1F2',
    react: '#568FA4',
    reactNative: '#33809B',
    springBoot: '#658D41',
    nextjs: '#000',
    swift: '#C27A44',
    illustrator: '#C9852F',
    figma: 'linear-gradient(180deg, #D95731 0%, #E77666 36.98%, #55B3F0 69.27%, #5CC685 100%)',
}

export default colors;